<script setup lang="ts">
import SelectionCircle from './SelectionCircle.vue';

interface Props {
    title: string;
    subtitle: string;
    secondSubtitle?: string;
    image?: string;
    value: string;
    modelValue: string;
}

const props = defineProps<Props>();

const emit = defineEmits<{
    (e: 'update:modelValue', value: string): void;
}>();

const select = () => {
    emit('update:modelValue', props.value);
};
</script>

<template>
    <label class="group relative flex cursor-pointer gap-3 xl:gap-5" @click="select">
        <!-- Custom Radio Circle -->
        <SelectionCircle :selected="modelValue === value" />

        <!-- Content -->
        <div class="flex flex-row-reverse gap-4 xl:flex-row xl:gap-5">
            <!-- Image -->
            <div
                class="relative flex h-[72px] w-[52px] shrink-0 items-center justify-center xl:h-[148px] xl:w-[105px]"
            >
                <img v-if="image" :src="image" alt="" class="h-full w-full object-contain" />
            </div>

            <div class="flex max-w-[250px] flex-col">
                <h3 class="mt-1 text-base font-semibold leading-none text-[#004646] xl:mt-0 xl:text-xl xl:leading-none">
                    {{ title }}
                </h3>
                <p class="mt-1 font-open text-[13px] leading-[18px] text-[#393734] xl:mt-2.5 xl:text-sm">
                    {{ subtitle }}
                </p>
                <p
                    v-if="secondSubtitle"
                    class="mt-1 font-open text-[13px] font-semibold leading-[18px] text-[#393734] xl:mt-2 xl:text-sm"
                >
                    {{ secondSubtitle }}
                </p>
            </div>
        </div>
    </label>
</template>
